// src/components/Course/CourseItem.tsx
import React, { useState } from 'react';
import { Course } from '../../types/interfaces'; // Import the Course type
import { Card, CardContent, Typography, CardActions, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Chip, Box } from '@mui/material';
import { Link as RouterLink, useNavigate } from 'react-router-dom';

const CourseItem: React.FC<{ course: Course, onDelete: (id: number) => void }> = ({ course, onDelete }) => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  const today = new Date().toISOString().split('T')[0];
  const isExpired = course.endDate < today;
  const isUpcoming = course.startDate > today;

  const handleDelete = async () => {
    await onDelete(course.id);
    setOpen(false);
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleCardClick = () => {
    navigate(`/course/${course.id}`);
  };

  const handleCardKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      handleCardClick();
    }
  };

  const stopCardClickPropagation = (event: React.SyntheticEvent) => {
    event.stopPropagation();
  };

  return (
    <Card
      sx={{ opacity: isExpired ? 0.7 : 1, cursor: 'pointer' }}
      onClick={handleCardClick}
      onKeyDown={handleCardKeyDown}
      role="button"
      tabIndex={0}
    >
      <CardContent>
        <Box display="flex" justifyContent="space-between" alignItems="flex-start">
          <Typography variant="h5" component="div">
            {course.name}
          </Typography>
          {isExpired && (
            <Chip 
              label="Päättynyt" 
              color="error" 
              size="small"
              sx={{ ml: 1 }}
            />
          )}
          {isUpcoming && (
            <Chip 
              label="Tulossa" 
              color="info" 
              size="small"
              sx={{ ml: 1 }}
            />
          )}
        </Box>
        <Typography variant="body2" color="textSecondary">
          {course.description}
        </Typography>
        <Typography variant="body2" color="textSecondary">
          {course.startDate} - {course.endDate}
        </Typography>
      </CardContent>
      <CardActions>
        <Button size="small" component={RouterLink} to={`/course/${course.id}`} onClick={stopCardClickPropagation}>
          Näytä
        </Button>
        <Button size="small" component={RouterLink} to={`/course/edit/${course.id}`} onClick={stopCardClickPropagation}>
          Muokkaa
        </Button>
        <Button size="small" color="secondary" onClick={(event) => {
          event.stopPropagation();
          handleClickOpen();
        }}>
          Poista
        </Button>
      </CardActions>

      <Dialog
        open={open}
        onClose={handleClose}
        onClick={stopCardClickPropagation}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Vahvista poisto"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Oletko varma että haluat poistaa kurssin "{course.name}"?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Peruuta
          </Button>
          <Button onClick={handleDelete} color="secondary" autoFocus>
            Poista
          </Button>
        </DialogActions>
      </Dialog>
    </Card>
  );
};

export default CourseItem;
